import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form";
import FormButton from "../FormButton";
import Input from "../Input";
import Select from "../Select";
import { insertKAMMeetingHttp } from "../../http/renewalHttp/RenewalHttp";
import { useEffect, useState } from "react";

export default function InsertMeetingModal({ customer_data, handleClicked, ...props }) {

    const [selectedProducts, setSelectedProducts] = useState([]);

    function handleClose() {
        handleClicked(false);
    }

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setSelectedProducts((prev) => [...prev, value]);
        } else {
            setSelectedProducts((prev) => prev.filter((item) => item !== value));
        }
    };

    async function handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());

        // Join selected products for the backend
        data.new_opps_product = selectedProducts.join(", ");
        data.new_opps_count = selectedProducts.length; // Sends the actual number (e.g., 3)
        data.domain_id = customer_data.domain_id;
        data.domain_name = customer_data.customerDomain;

        console.log("---------- SENDING MEETING DATA ----------");
        console.log("Full Payload:", data);

        const response = await insertKAMMeetingHttp(data);
        if (response && !response.error) {
            alert("Meeting Details Saved Successfully");
            handleClose();
        } else {
            alert("Failed to save meeting details.");
        }
    }

    const meetingTypes = [
        { id: 'onsite', value: 'onsite' },
        { id: 'online', value: 'online' }
    ].map(item => <option key={item.id} value={item.id}>{item.value}</option>);

    const productOptions = [
        "Renewal Discussion", "Renewal Expansion", "New Domain", "Jumpcloud", "Scalefusion", "Checkpoint",
        "Gemini Ultra", "Gemini Enterprise", "Okta", "Jamf",
        "Wizz", "AWS", "GCP", "MiniOrange"
    ];

    const percentageOptions = ["100%", "75%", "50%", "25%"].map(pct =>
        <option key={pct} value={pct}>{pct}</option>
    );

    return createPortal(
        <Div className="modal-backdrop" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <dialog
                open
                style={{
                    backgroundColor: 'white',
                    zIndex: '1001',
                    margin: 'auto',
                    padding: '25px',
                    width: '95%',
                    maxWidth: '550px',
                    maxHeight: '85vh',
                    overflowY: 'auto',
                    borderRadius: '10px',
                    border: 'none',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                }}
            >
                <Div className="modal-content" style={{ border: 'none' }}>
                    <h5 className="mb-3">Insert Meeting: {customer_data.customerDomain}</h5>
                    <hr />
                    <Form onSubmit={handleSubmit}>
                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">Meeting Type</label>
                            <Div className="col-sm-8">
                                <Select name="meeting_type" options={meetingTypes} defaultValue="" style={{ width: '100%' }} />
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">New Opps (Product)</label>
                            <Div className="col-sm-8" style={{ border: '1px solid #ced4da', borderRadius: '4px', padding: '10px', maxHeight: '150px', overflowY: 'auto' }}>
                                {productOptions.map((prod) => (
                                    <div key={prod} className="custom-control custom-checkbox mb-1">
                                        <input 
                                            type="checkbox" 
                                            name="new_opps_product" 
                                            value={prod} 
                                            id={`chk-${prod}`} 
                                            className="mr-2" 
                                            onChange={handleCheckboxChange} /* CRITICAL CHANGE: Added this */
                                        />
                                        <label htmlFor={`chk-${prod}`} style={{ cursor: 'pointer' }}>{prod}</label>
                                    </div>
                                ))}
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">Total Count</label>
                            <Div className="col-sm-8">
                                {/* CRITICAL CHANGE: Show the live length here */}
                                <p className="form-control-plaintext" style={{ fontWeight: 'bold', color: '#007bff' }}>
                                    {selectedProducts.length} Products Selected
                                </p>
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">Adoption</label>
                            <Div className="col-sm-8">
                                <Select name="adoption" options={percentageOptions} defaultValue="25%" style={{ width: '100%' }} />
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">Support Rating</label>
                            <Div className="col-sm-8">
                                <Select name="support_rating" options={percentageOptions} defaultValue="50%" style={{ width: '100%' }} />
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">Feedback</label>
                            <Div className="col-sm-8">
                                <textarea name="feedback" className="form-control" rows="2" style={{ width: '100%' }}></textarea>
                            </Div>
                        </Div>

                        <Div className="form-group row mb-3">
                            <label className="col-sm-4 col-form-label fw-bold">Followup Date</label>
                            <Div className="col-sm-8">
                                <Input name="followup_date" type="date" style={{ width: '100%' }} />
                            </Div>
                        </Div>

                        <Div className="d-flex justify-content-end mt-4 pt-3" style={{ borderTop: '1px solid #eee' }}>
                            <FormButton type="submit" className="btn btn-primary mr-2">Save Meeting</FormButton>
                            <FormButton type="button" className="btn btn-secondary" onClick={handleClose}>Close</FormButton>
                        </Div>
                    </Form>
                </Div>
            </dialog>
        </Div>,
        document.getElementById('modal')
    );
}